import React from "react";
import {useKeycloak} from "@react-keycloak/web";
import {useTranslation} from "react-i18next";
import {Redirect} from "react-router-dom";
// Material UI imports
import {Container} from "@material-ui/core";
// Local imports
import DataSourceForm from "./DataSourceForm";
// Project imports
import {LoadingBackdrop} from "../../common/Loading";
import {ErrorNotification} from "../../common/notifications";
import {DataSourceCreateDTO, DataSourceDTO} from "../../../models/library";
import ROUTES from "../../../routes/routes";
import {API, createApiConfig} from "../../../utils";
import {AxiosError} from "axios";

interface DataSourceNewState {
    dataSource: DataSourceDTO | null;
    dataSourceCreate: DataSourceCreateDTO;
    name: string;
}

export const DataSourceNew: React.FC = () => {
    //== Init =================================================================
    const [t] = useTranslation("libraries");
    const {keycloak, initialized} = useKeycloak();
    const initState: DataSourceNewState = {
        dataSource: null,
        dataSourceCreate: {
            name: "",
            description: "",
        },
        name: "init",
    };
    const [state, setState] = React.useState(initState);
    //== Effects ==============================================================
    React.useEffect(() => {
        if (state.name === "saving") {
            API.post<DataSourceDTO>(`/data-sources`, state.dataSourceCreate, createApiConfig(keycloak, initialized))
                .then((res) => {
                    setState({...state, dataSource: res.data, name: "saved"});
                })
                .catch((err: AxiosError) => {
                    setState({...state, name: "failed"});
                });
        }
    }, [keycloak, initialized, state, setState]);
    //== Handlers =============================================================
    const handleChange = (dataSource: DataSourceCreateDTO): void => {
        setState({...state, dataSourceCreate: dataSource});
    };
    const handleSubmit = (): void => {
        setState({...state, name: "saving"});
    };
    //== Render ===============================================================
    let appendix: JSX.Element | null = null;
    if (state.name === "saving") {
        appendix = <LoadingBackdrop />;
    }
    if (state.name === "failed") {
        appendix = <ErrorNotification message={t("definitions.data_sources.notifications.create_fail")} />;
    }
    if (state.name === "saved") {
        return <Redirect to={ROUTES.dataSource.create(state.dataSource?.id ?? "unknown")} />;
    }
    return (
        <Container maxWidth="md">
            <h1>{t("definitions.data_sources.new")}</h1>
            <DataSourceForm dataSource={state.dataSourceCreate} onChange={handleChange} onSubmit={handleSubmit} />
            {appendix}
        </Container>
    );
};

export default DataSourceNew;
